import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import mafiaIcon from '../../../../public/img/mafia-icon.svg';
const Image = styled.img `
  position: absolute;
  left: -34px;
  top: calc(50% - 15px);

  border-radius: 50%;
  box-shadow: 0px 4px 3.9px 0px rgba(0, 0, 0, 0.46);
`;
const MafiaIcon = () => {
    Image.defaultProps = {
        src: mafiaIcon
    };
    return (_jsx(Image, {}));
};
export default MafiaIcon;
